import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FSwitch } from "@ui/components/inputs/FSwitch";
import { FSelect } from "@ui/components/inputs/FSelect";
/**
 * "WhatsApp Alarm Section" of the AP / node alarm settings (super admins only): a maintenance switch that blocks all
 * WhatsApp alarms and the WhatsApp repeat policy. WhatsApp goes to the contacts whose WhatsApp chip is on.
 */
export const WhatsAppAlarmSection = ({ control, repeatOptions }) => {
    const { t } = useTranslation(["common"]);
    return (React.createElement(Box, { sx: { bgcolor: (theme) => theme.palette.background.paper, borderRadius: 4, px: 2, py: 1.5 } },
        React.createElement(Typography, { variant: "h5", sx: { color: "primary.darker", mb: 2 } }, t("common:headings.whatsAppAlarm", "WhatsApp Alarm Section")),
        React.createElement(Box, { sx: { mb: 2 } },
            React.createElement(FSwitch, { color: "error", name: "blockAllWhatsApp", control: control, label: t("common:labels.blockAllWhatsApp", "Block all WhatsApp alarms for maintenance") })),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { size: { xs: 12, md: 6 } },
                React.createElement(FSelect, { name: "whatsAppRepeat", control: control, label: t("common:labels.repeatAlarm"), options: repeatOptions })))));
};
